import {useEffect} from 'react';
import {TransactionStatus} from '@usedapp/core';

import {showError, showSuccess} from '~utils/toast';
import getErrorMessage from '~utils/getErrorMessage';

const defaultMessages = {
    successTitle: 'Success',
    successMessage: 'Transaction success',
    errorTitle: 'Error',
};
export type MessagesType = typeof defaultMessages;
export default function useShowStatus(
    status: TransactionStatus,
    messages: MessagesType = defaultMessages,
) {
    useEffect(() => {
        if (status.status === 'Exception' || status.status === 'Fail') {
            showError(getErrorMessage(status.errorMessage), messages.errorTitle);
        } else if (status.status === 'Success') {
            showSuccess(messages.successMessage, messages.successTitle);
        }
    }, [status]);
}
